import { memo, useState, useEffect, useRef } from 'react'
import didYouKnowData from '../../data/didYouKnow.json'
import { playSound } from '../../utils/soundFX'

function parseHighlights(text) {
  const parts = text.split(/\*([^*]+)\*/)
  return parts.map((part, i) =>
    i % 2 === 1
      ? <span key={i} className="dyk-highlight">{part}</span>
      : part
  )
}

export const DidYouKnow = memo(function DidYouKnow({ screen = 'home' }) {
  const entry = didYouKnowData.find(e => e.screen === screen)
  if (!entry) return null

  const {
    heading,
    paragraphs,
    position = 'mid-right',
    xOffset = '0vw',
    yOffset = '0vh',
    dismissable = false,
    reappearAfter = 30,
  } = entry

  const [dismissed, setDismissed] = useState(false)
  const timerRef = useRef(null)

  const handleClose = () => {
    playSound('DataPoint_Close')
    setDismissed(true)
    if (reappearAfter > 0) {
      timerRef.current = setTimeout(() => {
        setDismissed(false)
      }, reappearAfter * 1000)
    }
  }

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current) }
  }, [])

  if (dismissed) return null

  const offsetStyle = {
    '--dyk-x-offset': xOffset,
    '--dyk-y-offset': yOffset,
  }

  return (
    <div className={`did-you-know-panel dyk-pos--${position} dyk-screen--${entry.id}`} style={offsetStyle}>
      <div className="did-you-know-window">
        {dismissable ? (
          <div className="dyk-heading-row">
            {heading && <p className="dyk-heading">{parseHighlights(heading)}</p>}
            <button className="dyk-close" onClick={handleClose} aria-label="Close">✕</button>
          </div>
        ) : (
          heading && <p className="dyk-heading">{parseHighlights(heading)}</p>
        )}
        {paragraphs.map((text, i) => (
          <p key={i} className="dyk-body">{parseHighlights(text)}</p>
        ))}
      </div>
    </div>
  )
})
